// Display metadata only: never move, merge, remove, or reinterpret saved pieces.
const EPS=1e-7;
const same=(a,b)=>Math.abs(a-b)<EPS;
export const rectanglesOverlap=(a,b)=>a.x<b.x+b.width-EPS&&a.x+a.width>b.x+EPS&&a.y<b.y+b.height-EPS&&a.y+a.height>b.y+EPS;
const sameBox=(a,b)=>same(a.x,b.x)&&same(a.y,b.y)&&same(a.width,b.width)&&same(a.height,b.height);

export function overlapPresentation(items,bounds,overlaps=(a,b)=>rectanglesOverlap(bounds(a),bounds(b)),sameFootprint=(a,b)=>sameBox(bounds(a),bounds(b))) {
 const result=new Map(items.map(item=>[item.id,{opacity:1,overlapping:false,stackCount:1,stackTop:false}]));
 const stack=items.map((_,index)=>[index]);
 for(let i=0;i<items.length;i++)for(let j=i+1;j<items.length;j++){
  if(!overlaps(items[i],items[j]))continue;
  result.get(items[i].id).overlapping=true;result.get(items[j].id).overlapping=true;
  if(sameFootprint(items[i],items[j])){stack[i].push(j);stack[j].push(i);}
 }
 for(let index=0;index<items.length;index++){
  const state=result.get(items[index].id),count=stack[index].length;
  state.stackCount=count;state.stackTop=count>1&&index===Math.max(...stack[index]);
  // Large exact stacks stay translucent rather than becoming opaque after a
  // few layers. The count distinguishes identical pieces sharing one footprint.
  state.opacity=state.overlapping?Math.min(.5,1/(count+1)):1;
 }
 return result;
}

export function translucentHex(color,opacity=1) {
 if(opacity===1)return color;
 if(!/^#[0-9a-f]{6}$/i.test(color))throw Error('Use a six-digit hex fill color.');
 return `rgba(${[1,3,5].map(start=>parseInt(color.slice(start,start+2),16)).join(',')},${opacity})`;
}
